var a = {};
export {
  a as __exports
};
//# sourceMappingURL=index.es483.js.map
